module.exports = __webpack_public_path__ + "static/media/OldStandardTT-Bold.3aa02cd2.ttf";